jQuery(document).ready(function($) {

   // MENU OPEN



   $('#m-header_menu-icon').on('click',function() {
      var time = 100;
      var menuTime = 300;
      var menuAfter = time;

      $('.m-header__content__button__circle').delay(time).each(function (index) {
         $(this).delay(menuTime * index).queue(function () {
            $(this).addClass('transition');
            $(this).dequeue();
         });
         menuAfter = time + ( menuTime * 2);
      });

      if(window.innerWidth < 500) {
         setTimeout(function(){
            $('.m-menu').addClass('m-menu--open');
            $('body').addClass('overflow');
         }, menuAfter + 100);
         setTimeout(function(){
            $('#m-menu__bottom').addClass('transition');
         }, menuAfter + 200);
         setTimeout(function(){
            $('#m-menu__top').addClass('transition');
         }, menuAfter + 300);

      } else if(window.innerWidth > 500) {

         $('.m-menu').addClass('m-menu--open');
         $('body').addClass('overflow');
         $('#m-menu__bottom').addClass('transition');
         $('#m-menu__top').addClass('transition');

      }

   });


   $('#m-header_menu-icon__close').on('click',function() {

      if( $('.m-menu').hasClass('m-menu--open') ) {
         $('body').removeClass('overflow');
         $('#m-menu__bottom').removeClass('transition');
         $('#m-menu__top').removeClass('transition');
         $('.m-menu').removeClass('m-menu--open');
         $('.m-header__content__button__circle').removeClass('transition');
      }
   });


   $('#m-menu__top__item__link--search').on('click', function() {
      $('#s').focus();
      $('#m-header__search').addClass('m-header__search--open')
   });

   $('#m-menu__top__item__link--search-mobile').on('click', function() {
      $('#s').focus();
      $('#m-header__search').addClass('m-header__search--open')
   });

   $(document).on('click',function() {
      $('#m-header__search').removeClass('m-header__search--open');
   });

   $('.m-header__search, #m-menu__top__item__link--search,#m-menu__top__item__link--search-mobile').click(function (event) {
      event.stopPropagation();
   });







   $(document).on('click',function() {
      $('#m-header__menu__search').removeClass('m-header__menu__search--open');
   });

   $('.m-header__menu__search, #m-header__menu__search-button').click(function (event) {
      event.stopPropagation();
   });


   function openSubmenu() {
      if(window.innerWidth < 1025) {
         $( ".m-menu__bottom__item" ).each(function() {
            $(this).on('click',function (event) {
               $('.m-menu__bottom__item').removeClass('m-menu__bottom__item--open');
               var icon = $(this).find('.m-menu__bottom__item__submenu');
               if( icon.hasClass('m-menu__bottom__item__submenu--open') ) {

                  $(this).removeClass('m-menu__bottom__item--open')
                  icon.removeClass('m-menu__bottom__item__submenu--open');

               } else {
                  $('.m-menu__bottom__item__link').removeClass('m-menu__bottom__item--open')
                  $(this).addClass('m-menu__bottom__item--open')
                  $('.m-menu__bottom__item__submenu').removeClass('m-menu__bottom__item__submenu--open');
                  icon.addClass('m-menu__bottom__item__submenu--open');
               }
            });

         });
         $('#m-menu__top__item__link__lang').on('click',function (event) {
            var parent = $(this).parent();

           if( parent.find('.m-menu__top__item__submenu').hasClass('m-menu__top__item__submenu--open')) {
              parent.find('.m-menu__top__item__submenu').removeClass('m-menu__top__item__submenu--open')
           } else {
              parent.find('.m-menu__top__item__submenu').addClass('m-menu__top__item__submenu--open')
           }

         });
      }
   }

   $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      if(scrollTop > 10) {
         $('.m-header__lang').addClass('m-header__lang--hide');
      } else {
         $('.m-header__lang').removeClass('m-header__lang--hide');
      }
   });


   /**
    * Bouton Top
    * Permet de retourner au haut de page
    */

   $('#m-button-top').click(function(){
      $('html, body').animate({scrollTop : 0},800);
      return false;
   });

   $(window).on("load", function () {
      openSubmenu();
   });


   function checkFile(file) {
      if(file) {
         var extension = file.substr((file.lastIndexOf('.') +1));
         if (!/(pdf)$/ig.test(extension)) {
            return false;
         }
         return true;
      }
   }

   $('a').on('click',function() {
      var hrefLink = $(this).attr('href');
      if(checkFile(hrefLink)) {
         var libele = window.location.pathname;
         console.log('gtag reussi')
         gtag('event', hrefLink , {
            'event_category': 'téléchargement pdf',
            'event_label': libele
         });
      } 
   })


});
